/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Cta_BodyInputs */

const en_marketing_cta_body = /** @type {(inputs: Marketing_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start at the interesting part. Get the foundation, keep the repository, and ship your product on it.`)
};

const es_marketing_cta_body = /** @type {(inputs: Marketing_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza por la parte interesante. Llévate la base, conserva el repositorio y lanza tu producto sobre él.`)
};

const fr_marketing_cta_body = /** @type {(inputs: Marketing_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencez par la partie intéressante. Prenez la base, gardez le dépôt et lancez votre produit dessus.`)
};

/**
* | output |
* | --- |
* | "Start at the interesting part. Get the foundation, keep the repository, and ship your product on it." |
*
* @param {Marketing_Cta_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_cta_body = /** @type {((inputs?: Marketing_Cta_BodyInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Cta_BodyInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_cta_body(inputs)
	if (locale === "es") return es_marketing_cta_body(inputs)
	return fr_marketing_cta_body(inputs)
});